import { Dialog, DialogContent } from '@repo/shadcn';
import React from 'react';

interface ModalProps {
    children: React.ReactNode;
    onClickDialog?: any;
    open?: boolean;
    action?: React.ReactNode;
    title?: string;
}
function Modal({ open, children, onClickDialog }: ModalProps) {
    return (
        <Dialog onOpenChange={onClickDialog} modal open={open}>
            <DialogContent className="z-50 w-[calc(100vw-1rem)] max-w-2xl overflow-hidden p-0 sm:w-[calc(100vw-2rem)]">
                <div className="max-h-[calc(100dvh-2rem)] overflow-y-auto p-6 [scrollbar-gutter:stable]">
                    {children}
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default Modal;
